module.exports = __webpack_public_path__ + "static/media/tomato-pizza.7b9148d8.jpg";